import $dayjs from '@/services/date'
import i18n from '@plugins/vue-i18n'

/**
 * Parses a .NET TimeSpan string into a dayjs duration.
 * @param {string} timeSpan e.g. '06:00:00' or '1.02:30:00'
 * @returns {dayjs.Duration | null}
 */
const parseTimeSpan = (timeSpan) => {
  const match = /^(?:(\d+)\.)?(\d{1,2}):(\d{2}):(\d{2})/.exec(timeSpan ?? '')

  if (!match) return null

  const [, days = 0, hours, minutes, seconds] = match

  return $dayjs.duration({
    days: Number(days),
    hours: Number(hours),
    minutes: Number(minutes),
    seconds: Number(seconds),
  })
}

/**
 * Returns a localised label for a .NET TimeSpan string.
 * @param {string} timeSpan e.g. '01:30:00'
 * @returns {string} e.g. '1 hour 30 minutes', or the original value if it can't be parsed
 */
const getDurationLabel = (timeSpan) => {
  const duration = parseTimeSpan(timeSpan)

  if (!duration) return timeSpan

  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()

  const label = [
    hours && i18n.tc('general.time.inHours', hours, { count: hours }),
    minutes && i18n.tc('general.time.inMinutes', minutes, { count: minutes }),
  ]
    .filter(Boolean)
    .join(' ')

  return label || timeSpan
}

export { parseTimeSpan, getDurationLabel }
